// АРИС shared exports — consumed by @aris/api and @aris/web.
// Keep this file thin (re-exports only); content lives in topic modules.
import { installRuZodErrorMap } from './lib/zod-ru';

export * from './enums';
export * from './auth';
export * from './users';
export * from './constants';
export * from './settings';
export * from './workload';
export * from './absence';
export * from './profile';
export * from './projects';
export * from './expenses';
export * from './section';
export * from './objects';
// Блок 2 «Трекер объектов» Ф2 · В1 — «работа», договор, ссылки на
// исходные данные объекта.
export * from './work';
export * from './contract';
// Блок 2 «Трекер объектов» Ф2 · В2b — команда объекта (проекция поверх
// `ProjectParticipant` и `Work`).
export * from './project-team';
export * from './clients';
export * from './dashboard';
// Блок 2 «Трекер объектов» Ф7 · В13′ — сводные показатели новым рядом на
// дашборде (Р-134) и лента «Сроки». Когорта у ряда СВОЯ — «по бюро», а не по
// отделу, как у плиток `dashboard.ts`; отсюда и отдельный модуль.
export * from './summary';
export * from './llm';
export * from './transcription';
export * from './bot';
// Блок 2 «Трекер объектов» Ф5 · В7 — реестр видов уведомлений и протокол
// дедупа (`dedupKey`). Формула ключа определена ТАМ и больше нигде.
export * from './bot-notifications';
// Блок 2 · Ф7 · В11-a (Р-132) — лента уведомлений на сайте: договор
// `GET /notifications/me` и ЕДИНСТВЕННОЕ чтение исхода строки очереди.
export * from './notification-feed';
// Блок 2 · Ф4-П (Р-82) — «это мой сотрудник»: один предикат на сервер и веб.
// Правило прав, которое ОБЕ стороны выписывали руками, пока общего места не
// было; разбор — в самом модуле.
export * from './lib/own-department';
// Блок 2 · Ф8 · В-О1а — восемь изменяемых прав: зеркала `UserRight` и
// `RightEffect`, таблица пар «вести → видеть» и ступень 1 резолвера (ОТКУДА
// право: отнято / добавлено / по должности). Одна функция на сервер и веб.
export * from './rights';
// Блок 2 · Ф8 · В-О1б — договор маршрутов выдачи прав: тело `PUT`, карточка
// человека, сводный список. Правило «откуда право» остаётся в `rights.ts`.
export * from './user-rights';
// Блок 2 · Ф5 · В9.9 (Р-104, Р-105) — нижние границы записи задним числом:
// час не глубже начала прошлого месяца, задача СЕБЕ не глубже недели. Одна
// арифметика на сервер и на веб; «сегодня» приходит параметром.
export * from './lib/backdate-bounds';
export * from './lib/plural-ru';
// Блок 2 · Ф7 · В13′ (Р-141) — «И. Фамилия» для узких мест показа. Правило
// одно на систему; где оно НЕ применяется — названо в самом модуле.
export * from './lib/person-name';
export * from './lib/money-ru';
export * from './lib/zod-ru';

// Русские тексты вместо английских дефолтов zod («Required», «Invalid uuid»,
// «Unrecognized key(s) in object: 'projectId'», …). Ставится здесь, побочным
// эффектом импорта пакета: схемы живут здесь же, и потребителю не нужно
// помнить про установку.
//
// ЧЕГО ЭТА УСТАНОВКА НЕ ПОКРЫВАЕТ. zod 3.25 — двойной пакет (`import` →
// `index.js`, `require` → `index.cjs`), а этот пакет собран только под
// CommonJS. Значит карта ложится на CJS-экземпляр; потребитель в ESM,
// импортирующий zod напрямую, может получить ВТОРОЙ экземпляр со своими
// английскими текстами. Сегодня сборка сводит оба к одному, дефект
// латентный. Веб на всякий случай ставит карту сам, своим импортом zod —
// см. `apps/web/src/main.tsx`.
// Явные сообщения в схемах сильнее карты и остаются как есть.
installRuZodErrorMap();
